var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("The requested page does not exist")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to index")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }